// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "hash": "11e1f0c",
    "fullHash": "11e1f0c3728194b3687ab4b6f826469df9115d18",
    "branch": "HEAD",
    "tag": null
};
/* tslint:enable */
/* eslint-enable */
